import ApiRequest from '../../Apis/request'

export default class ApiCopro {
  constructor() {
    this.apiRequest = new ApiRequest()
  }
  async getCoproFiche(id, params = {}) {
    try {
      const res = await this.apiRequest.get(`copros_fiche/${id}`, params)
      return res
    } catch (error) {
      return error.response
    }
  }
  async updateCoproFiche(id, payload) {
    try {
      const res = await this.apiRequest.put(`/copros_fiche/${id}`, payload)
      return res
    } catch (error) {
      return error.response
    }
  }
}
